import { render, staticRenderFns } from "./purchaselist.vue?vue&type=template&id=53d33626&scoped=true"
import script from "./purchaselist.vue?vue&type=script&lang=js"
export * from "./purchaselist.vue?vue&type=script&lang=js"
import style0 from "./purchaselist.vue?vue&type=style&index=0&id=53d33626&prod&lang=css"
import style1 from "./purchaselist.vue?vue&type=style&index=1&id=53d33626&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d33626",
  null
  
)

export default component.exports